import { render, staticRenderFns } from "./setting-keys.vue?vue&type=template&id=a82da2cc"
import script from "./setting-keys.vue?vue&type=script&lang=js"
export * from "./setting-keys.vue?vue&type=script&lang=js"
import style0 from "./setting-keys.vue?vue&type=style&index=0&id=a82da2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports